import { IWorkoutStatisticsPerWorkout } from "../models/workoutStatisticsViewModel";
import { shortDate } from "../utils/statisticsFormat";
import { CHART_ACCENT } from "../charts/registerCharts";
import { ScrollableBarChart } from "./ScrollableBarChart";
import styles from "../WorkoutStatistics.module.scss";

interface IVolumePerWorkoutChartProps {
  perWorkout: IWorkoutStatisticsPerWorkout[];
}

/** Total kilograms (volume) per workout across the period. */
export const VolumePerWorkoutChart = ({
  perWorkout,
}: IVolumePerWorkoutChartProps) => {
  const data = {
    labels: perWorkout.map((w) => shortDate(w.date)),
    datasets: [
      {
        label: "Обем (кг)",
        data: perWorkout.map((w) => Math.round(w.volumeKg)),
        backgroundColor: CHART_ACCENT,
        borderRadius: 6,
        maxBarThickness: 38,
      },
    ],
  };

  return (
    <div className={styles.chart_card}>
      <h3 className={styles.chart_title}>Обем на тренировка</h3>
      <ScrollableBarChart data={data} count={perWorkout.length} />
    </div>
  );
};
